if (!customElements.get('mom-decant-discovery')) {
  customElements.define('mom-decant-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.grid = this.querySelector('[data-decant-grid]');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-status]');
      this.more = this.querySelector('[data-more]');
      this.retry = this.querySelector('[data-retry]');
      this.limit = 24;
      this.loadedPages = new Set([Number(this.dataset.page) || 1]);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(true); });
      this.form.addEventListener('change', () => this.apply(true));
      this.form.addEventListener('reset', () => setTimeout(() => this.apply(true), 0));
      this.more.addEventListener('click', () => { this.limit += 24; this.render(); });
      this.retry.addEventListener('click', () => this.load());
      this.onPop = () => { this.readUrl(); this.apply(false); };
      window.addEventListener('popstate', this.onPop);
      this.load();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); }
    async load() {
      this.retry.hidden = true;
      this.status.textContent = this.dataset.loading;
      const pages = Number(this.dataset.pages);
      try {
        const pending = Array.from({length: Math.max(0, pages)}, (_, i) => i + 1).filter(n => !this.loadedPages.has(n));
        for (let i = 0; i < pending.length; i += 3) {
          const results = await Promise.all(pending.slice(i, i + 3).map(async page => {
            const url = new URL(this.dataset.feedUrl, location.origin);
            url.searchParams.set('view', 'mom-decants-feed');
            url.searchParams.set('page', page);
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 20000);
            try {
              const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal});
              if (!response.ok) throw new Error('Decant feed unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const feed = doc.querySelector('[data-decant-feed]');
              if (!feed || Number(feed.dataset.page) !== page) throw new Error('Incomplete decant feed');
              return {page, cards: Array.from(feed.querySelectorAll('[data-decant-id]'))};
            } finally {
              clearTimeout(timeout);
            }
          }));
          results.forEach(({page, cards}) => { cards.forEach(card => this.grid.append(card)); this.loadedPages.add(page); });
        }
        const seen = new Set();
        this.cards = Array.from(this.grid.querySelectorAll('[data-decant-id]')).filter(card => {
          if (seen.has(card.dataset.decantId)) { card.remove(); return false; }
          seen.add(card.dataset.decantId); return true;
        });
        this.populate('mp_brand', this.cards.map(c => c.dataset.brand));
        this.populate('mp_scent', this.cards.flatMap(c => c.dataset.scents.split('|').filter(Boolean)));
        this.form.querySelector('fieldset').disabled = false;
        this.readUrl();
        this.apply(false);
      } catch (error) {
        this.status.textContent = this.dataset.failed;
        this.retry.hidden = false;
      }
    }
    populate(name, values) {
      const select = this.form.elements[name];
      while (select.options.length > 1) select.remove(1);
      Array.from(new Set(values)).sort((a,b) => a.localeCompare(b)).forEach(value => select.add(new Option(value, value)));
    }
    readUrl() {
      const params = new URL(location.href).searchParams;
      ['mp_brand','mp_scent','mp_price','mp_available','mp_sort'].forEach(name => {
        this.form.elements[name].value = params.get(name) || (name === 'mp_sort' ? 'available' : '');
      });
    }
    apply(writeUrl) {
      if (!this.cards) return;
      this.limit = 24;
      if (writeUrl) {
        const url = new URL(location.href);
        for (const [name, value] of new FormData(this.form)) {
          if (value && !(name === 'mp_sort' && value === 'available')) url.searchParams.set(name, value);
          else url.searchParams.delete(name);
        }
        history.pushState({}, '', url);
      }
      this.render();
    }
    render() {
      const values = Object.fromEntries(new FormData(this.form));
      const filtered = this.cards.filter(card => (!values.mp_brand || card.dataset.brand === values.mp_brand)
        && (!values.mp_scent || card.dataset.scents.split('|').includes(values.mp_scent))
        && (!values.mp_available || card.dataset.available === values.mp_available)
        && (values.mp_price === '' || Number(card.dataset.price) <= Number(values.mp_price) * 100));
      filtered.sort((a,b) => {
        if (values.mp_sort === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (values.mp_sort === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (values.mp_sort === 'available' && a.dataset.available !== b.dataset.available) return a.dataset.available === 'true' ? -1 : 1;
        return a.dataset.title.localeCompare(b.dataset.title);
      });
      this.cards.forEach(card => { card.hidden = true; });
      filtered.slice(0, this.limit).forEach(card => { card.hidden = false; this.grid.append(card); });
      this.status.textContent = `${filtered.length} ${this.dataset.countLabel}`;
      this.querySelector('[data-empty]').hidden = filtered.length !== 0;
      this.more.hidden = filtered.length <= this.limit;
    }
  });
}
